// extracted by mini-css-extract-plugin
export var actionButton = "_j5-t";
export var buttonContainer = "_j5-0";
export var buttonContainer2 = "_j5-1";
export var buttonSection = "_j5-2";
export var details = "_j5-3";
export var dropdownItem = "_j5-5";
export var dropdownItemsContainer = "_j5-4";
export var fileInput = "_j5-r";
export var headerButton = "_j5-6";
export var icon = "_j5-7";
export var input = "_j5-8";
export var macroListItem = "_j5-9";
export var mainContent = "_j5-a";
export var microText = "_j5-b";
export var modal = "_j5-w";
export var optionsButton = "_j5-c";
export var paperclip = "_j5-s";
export var pillContent = "_j5-d";
export var preview = "_j5-e";
export var preview2 = "_j5-f";
export var quillEditor = "_j5-q";
export var selectedMacro = "_j5-g";
export var sidebar = "_j5-h";
export var sidebarHeader = "_j5-j";
export var sidebarList = "_j5-i";
export var sidebarListItem = "_j5-k";
export var sidebarSearch = "_j5-l";
export var snoozeDurationWrapper = "_j5-v";
export var statusPillContainer = "_j5-m";
export var tagsContainer = "_j5-n";
export var unselectedMacro = "_j5-o";
export var variable = "_j5-u";
export var wrapper = "_j5-p";